import { api, formatApiError } from "./api";
import { toast } from "sonner";

export async function downloadCsv(endpoint, filename) {
  try {
    const res = await api.get(endpoint, { responseType: "blob" });
    const blob = new Blob([res.data], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success("Downloaded " + filename);
  } catch (err) {
    toast.error(formatApiError(err));
  }
}
